<template>
  <div class="historyCon">
    <days @getdays='getDays'></days>
    
    <div v-if='lineArr.length>0' class='moving'>
        <p @click='movers' v-if="isStop"><van-icon name="play-circle" />播放轨迹</p>
        <p @click='stops' v-else><van-icon name="stop-circle-o" />结束播放</p>
    </div>
    <div id="container"></div> 
    <div class='mapList'>
       <p class="mapTxt" @click='show=!show'>起点-终点&nbsp;<van-icon name="arrow-down" v-if="!show" /><van-icon name="arrow-up" v-else /></p>
       <div class='history' v-if="show">
         <p><span class="cicle"></span><span class='text'>{{address[0]}}</span></p>
         <p><span class="cicle" style="background:#FF804D"></span><span class='text'>{{address[1]}}</span></p>
       </div>
    </div>
  </div>
</template>
<script>
import days from '@/components/dateTop.vue';
import {getPathTrack} from "@/api/api.map";
  export default {
    data() {
      return {
        map:'',
        address:['',''],
        lineArr:[],
        marker:'',
        isStop:true,
        show:true,
        from:'',
        date:'',
        height:'',
        times:''
      }
    },
    components:{days},
    mounted(){
      setTimeout(()=>{
                this.getMaps();
      },500);
    },
    methods: {
      getMaps(){
        var map = new AMap.Map('container', {
            resizeEnable: true,
            zoom: 17,
        });
       
        this.map=map;
        let date=new Date();
        this.date=this.pubMethod.formatDate(date,'yyyy-MM-dd');
        this.getTrack(this.date);
      },
      getDays(item){
        // this.num=i;
        this.stops();
        this.map.clearMap(this.marker);
        this.getTrack(item.date);
      },
      getTrack(date){
        let self=this;
        let stuId=this.loginUser.studentId||sessionStorage.stuId;
        console.log(11,stuId);
         getPathTrack({
              date:date,
              studentId:stuId
           }).then((data) => {
            if (data && data.result) {
                      let lineArr =[];
                      if(data.result.pointList&&data.result.pointList.length>0){
                        data.result.pointList.forEach((item,i)=>{
                          lineArr.push([item.gaodeLongitude,item.gaodeLatitude])
                          if(i==0||i==data.result.pointList.length-1){
                            setTimeout(()=>{
                              this.getAddress(i,[item.gaodeLongitude,item.gaodeLatitude]);
                           },1000)
                            
                          }
                        })
                      }else{
                        this.show=false;
                        this.$toast('暂无轨迹数据');
                        return false;
                      }
                      self.lineArr=lineArr;
               
                      var marker = new AMap.Marker({
                          map: self.map,
                          icon: require("@/assets/img/location/peo.png"),
                          position:lineArr[0],
                          offset: new AMap.Pixel(-20,-32),
                      });
                    
                      // 绘制轨迹
                      var polyline = new AMap.Polyline({
                        map: self.map,
                          path: lineArr,
                          showDir:true,
                          strokeColor: "#745ef3",  //线颜色
                          strokeWeight: 6,      //线宽
                          // strokeStyle: "solid"  //线样式
                      });
                      var passedPolyline = new AMap.Polyline({
                          strokeColor: "#745ef3",  //线颜色
                          strokeWeight: 6,      //线宽
                      });
                      
                      marker.on('moving', function (e) {
                          passedPolyline.setPath(e.passedPath);
                      });
                    self.marker=marker;
                    self.map.setFitView();
                
            }else{
              this.$toast(data.message);
            }
         })
      },
      movers(){
        let self=this;
        this.isStop=false;
        let lineArr=this.lineArr;
        let lng1=lineArr[this.lineArr.length-1].lng,lat1=lineArr[this.lineArr.length-1].lat;
        this.marker.moveAlong(lineArr, 200);
        this.times=setInterval(()=>{
          let str=self.marker.getPosition();
          let lng=str.lng,lat=str.lat;
        
          if(lng==lng1&&lat==lat1){
            this.isStop=true;
            clearTimeout(this.times);
          }
        },2000)
      },
      stops(){
        this.isStop=true;
        if(this.lineArr.length>0){
            this.marker.stopMove();
            clearTimeout(this.times);
        }
        
      },
      //获取轨道起始点位置
      getAddress(i,lnglat){
        let self=this;
         AMap.plugin('AMap.Geocoder', function() {
              var geocoder = new AMap.Geocoder({
                      // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
                        city: '全国'
                });
                  geocoder.getAddress(lnglat, function(status, result) {
                    if (status === 'complete'&&result.regeocode) {
                      if(i==0){//起始位置
                       self.$set(self.address,0,result.regeocode.formattedAddress)
                      }else{
                        self.$set(self.address,1,result.regeocode.formattedAddress)
                      }
                      self.show=true;
                    }else{
                        self.$toast('根据经纬度查询地址失败')
                    }
                  });
              });
           
      }
      
    },
  }
</script>
<style lang="scss" >
.historyCon{
  height: 100%;
  .amap-icon img{
    width: 40px;
    left: 0;
    // box-shadow: 0px 7px 10px 0px rgba(186,194,211,0.8);
    // border-radius: 50%;
  }
  .moving{
    position: absolute;
    bottom: 2.3rem;
    right:10px;
    background:#fff;
    border:1px solid #2403DF;
    border-radius:19px;
    padding:8px 10px;
    margin-left: 10px;
    font-size: .14rem;
    color: #666;
    z-index: 3;
    p{
      display:flex;
    }
    i{
      color:#2403DF;
      font-size:.2rem;
      margin-right: 4px;
    }
  }
  .mapContent{
    position: relative;
    z-index: 4;
   
  }
  #container{
    height:100%;
    width:100%;
    z-index: 1;
 }
 .mapList{
   position: fixed;
   bottom: 0px;
   left: 0px;
   border-radius:.2rem .2rem 0px 0px;
   padding:.2rem;
   font-size: .15rem;
   color: #999;
   background: #fff;
   width: 100%;
   z-index: 2;
   .history{
     margin-top:20px;
     position: relative;
     color:#666;
     padding-left:20px;
     font-size: .15rem;
     
     p{
       padding-bottom: 22px;
       position: relative;
       margin-bottom: 10px;
       &:last-child{
         margin-bottom: 0px;
       }
       .text{
          overflow:hidden;
          text-overflow: ellipsis;
          word-break:break-all;
          display:-webkit-box;
          -webkit-box-orient:vertical;
          -webkit-line-clamp:2;
       }
       
     }
     p:first-child{
         &::before{
          content: '';
          height: 80%;
          width: 2px;
          display: block;
          position: absolute;
          border-left: 1px dashed #ccc;
          left: -16px;
          top: 22px;
         }
       }
   }
   .cicle{
      width:10px;
      height:10px;
      border-radius:50%;
      display: inline-block;
      margin-right: 10px;
      background:#0BCC9E ;
      margin-left: -20px;
      position: absolute;
      top: 5px;
   }
 }
}

</style>